<template>
	<div class="mb-4 pb-4 border-bottom-2" v-if="total_unpaid > 0">
		<div class="p-3 rounded-6 bg-history border-danger">
			<div v-if="is_load" class="w-100 text-center py-4">
				<loader />
			</div>
			<div v-else class="row slim-grid-row">
				<div class="col-12" v-if="error!=''"><p class="body-3 text-danger text-center w-100">{{error}}</p></div>
				<template v-else>
					<div class="col-8 align-self-center">
						<p class="mb-0 body-3-1 text-truncate">Unpaid Bill</p>
	          <p class="mb-0 body-2-2 font-bold text-16 text-danger">{{formatCurrency(total_unpaid)}}</p>
					</div>
					<div class="col-4 align-self-center">
						<div class="w-100 bg-green rounded-6 p-3 text-center cursor-pointer" @click="goToBillPage">
							<p class="mb-0 body-3-3-2 text-white">PAY NOW</p>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
  import {get} from '@/services/index.js';
  import {formatCurrency, formatDate} from '@/utils/index.js';

  export default{
  	props: {
  		is_validate_session:{
  			type: Boolean,
  			default: false
  		}
  	},
  	data(){
  		return{
  			total_unpaid: 0,
  			is_load: true,
  			error: ''
  		}
  	},
  	mounted(){
  		this.loadFirstData()
  	},
  	methods:{
      ...mapGetters(['getMerchant','getRestaurantAuth']),
      ...mapMutations(['setRestaurantAuth']),
      formatCurrency(data) {
        return formatCurrency(data);
      },
      goToBillPage(){
	    	this.$router.push({
	        path: "/" + this.getMerchant().code + "/r/payment-bill",
	      });
	    },
	    loadFirstData(){
	    	this.is_load = true
	    	this.error = ''
	    	if(this.is_validate_session){
	    		this.validateSession().then(session_res=>{
	    			if(session_res===true){
	    				this.getGuestBill().then(bill_res=>{
	    					if(bill_res!==true){
	    						this.error = bill_res
	    					}
	    					this.is_load = false
	    				})
	    			}else{
	    				this.is_load = false
    					this.error = session_res
    					this.$emit('session_exp')
	    			}
	    		})
	    	}else{
	    		this.getGuestBill().then(bill_res=>{
  					if(bill_res!==true){
  						this.error = bill_res
  					}
  					this.is_load = false
  				})
	    	}
	    },
	    validateSession(){
	    	return new Promise(done=>{
		    	get("CORE_RESTO","v2/session/validate",{
						merchant_id: this.getMerchant().id
					},'restaurant_session').then(response=>{
						let res = response.data
						if(res.success){
							done(true)
						}else{
							let params = [
								{
									key: 'name',
					    		value: ''	
								},
								{
									key: 'session',
					    		value: ''	
								},
							]
							this.setRestaurantAuth(params)
							done(false)
						}
					})
	    	})
	    },
	    getGuestBill(){
      	return new Promise(done=>{
		    	get("CORE_RESTO","v2/session/bill",{
						merchant_id: this.getMerchant().id
					},'restaurant_session').then(response=>{
						let res = response.data
						if(res.success){
							res.data.forEach(item=>{
								this.total_unpaid += item.total_outstanding
							})
							done(true)
						}else{
							done(res.message)
						}
					})
	    	})
      }
  	}
  }
</script>


// WEBPACK FOOTER //
// src/components/restaurant-v2/unpaidBill.vue